import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { igolfMappingRequest } from "API/apiConfig";
import { AdminLogin } from "API/apiRequest";
import { Encryption } from "services/encrypt";

const initialState = {
  status: "idle",
  login_status: false,
  redirectTo: "",
};

export const login = createAsyncThunk("/adminUserLogin", async (userData) => {
  //   let res = await axiosInstance.get("", userData);
  let res =await igolfMappingRequest(AdminLogin, userData, 
    // userData.username
    )
    .then((res) => res)
    .catch((error) => error);
  // let resData = res;
  let resData = {data:res?.data}
  return resData;
});

export const LoginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    logout: (state) => {
      // localStorage.removeItem("secretKey")
      localStorage.clear();
      state.login_status  = false;
    },
  },

  extraReducers: {
    [login.pending]: (state) => {
      state.status = "loading";
    },
    [login.fulfilled]: (state, { payload }) => {

      if (payload?.data?.Status === 1) {
        state.login_status = true;
        state.status = "idle";
      //  let xyz=  Encryption(payload?.data?.secretKey);
        localStorage?.setItem("secretKey", Encryption(payload?.data?.secretKey));
        localStorage.setItem("id_adminuser",payload?.data?.id_adminuser)
      }
    },
    [login.rejected]: () => {
      toast.error("Email/Password is incorrect", {
        type: "error",
        hideProgressBar: true,
        autoClose: 2500,
      });
    },
  },
});

export const { logout} = LoginSlice.actions;

export default LoginSlice.reducer;
